import { Outlet } from "react-router-dom";
import Navbar from './Header';
import Footer from './Footer'

export default function Layout() {
    return (
        <>
            <Navbar />
            <main>
                <Outlet />
            </main>
            <Footer/>
        </>
    )
}